import React from 'react';
import { Modal } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import UploadDocuments from '../../../../Components/UploadDocuments/UploadDocuments';

function ImportModal({ showUploadModal, closeUploadModal, docRef, addDocument, loader }) {
  const { t } = useTranslation('common');

  return (
    <Modal show={showUploadModal} className="common-custom-modal modal-medium-2x color-way-modal" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <Modal.Title id="contained-modal-title-vcenter">{t('POMS.GRADING_GROUP.IMPORT_MODAL.UPLOAD_FILE')}</Modal.Title>
          <span onClick={closeUploadModal} className="icon-close cursor-pointer" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <UploadDocuments setShowGradingGroupError={() => {}} hideName ref={docRef} accept=".xlsx, .xls" fromGrading />

        <div className="common-model-footer mt-16">
          {/* <button className="btn btn-default" type="button" onClick={closeUploadModal}>
            {t("POMS.GRADING_GROUP.IMPORT_MODAL.CANCEL")}
          </button> */}
          <button onClick={addDocument} type="button" className="btn p-0" disabled={loader}>
            {loader ? <Spinner animation="border" /> : <i className="icon-Tick-1 f-24" />}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ImportModal;
